var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"mt-2 d-flex flex-wrap"},'div',_vm.$attrs,false),_vm.$listeners),[_c('v-img',{attrs:{"src":_vm.stickerURL,"max-height":"100","max-width":"100"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }